import { MemberManagementMenu } from './MemberManagementMenu';
import { RoleCell } from './RoleCell';
import { SubscriptionCell } from './SubscriptionCell';

import { AccountDisplay } from '~/components/ui/AccountDisplay';
import { Checkbox } from '~/components/ui/Checkbox';
import { TableRow } from '~/components/ui/Table';

import type { OrganizationData, OrganizationMembership } from '~/types/organization';
import type { UserData } from '~/types/user';
import { classNames } from '~/utils/classNames';

interface MemberRowProps {
  member: OrganizationMembership;
  isReadonlyView: boolean;
  organization: OrganizationData;
  refetchMembers: VoidFunction;
  user: UserData;
  isChecked: boolean;
  selectMember: (username: string) => void;
  isOnboarding: boolean;
}

export const MemberRow = ({
  member,
  isReadonlyView = true,
  user,
  isChecked,
  refetchMembers,
  selectMember,
  organization,
  isOnboarding,
}: MemberRowProps) => {
  const isSelf = user.username === member.user.username;

  const renderActions = () => {
    if (isReadonlyView || isSelf) {
      return null;
    }

    return (
      <div className="col-span-3 flex justify-center">
        <MemberManagementMenu organization={organization} usernames={[member.user.username]} />
      </div>
    );
  };

  return (
    <TableRow
      className={classNames(
        'grid items-center gap-4 text-sm text-bolt-ds-textSecondary bg-bolt-ds-surface',
        !isReadonlyView ? 'grid-cols-24' : 'grid-cols-20',
      )}
    >
      {!isReadonlyView && (
        <div className="col-span-1">
          <Checkbox checked={isChecked} onChange={() => selectMember(member.user.username)} />
        </div>
      )}

      <div className="col-span-9 pl-1">
        <AccountDisplay
          user={member.user}
          title={member.user.name || member.user.username}
          description={member.user.pending ? 'Pending invite' : member.user.email}
          lineClassName="max-w-unset"
        />
      </div>

      <div className="col-span-5">
        <RoleCell
          isSelf={isSelf}
          isReadonlyView={isReadonlyView}
          member={member}
          organization={organization}
          refetchMembers={refetchMembers}
        />
      </div>

      <div className="col-span-6 flex justify-center">
        <SubscriptionCell
          isSelf={isSelf}
          refetchMembers={refetchMembers}
          isReadonlyView={isReadonlyView}
          isOnboarding={isOnboarding}
          member={member}
          organization={organization}
        />
      </div>

      {renderActions()}
    </TableRow>
  );
};
